/**
 *  用户相关 API 地址
 *  @swagger http://bp-partner-bff.t-sy-in.earth.xcloud.lenovo.com/swagger-ui.html
 */
import { IAjaxConfig } from '../helpers';
export class EnumApiLicense {
  /**
   * @method get 授权牌入口校验
   * @params
   */
  readonly license_entry_valid: IAjaxConfig = {
    url: '/api/gateway/content-bff/v1/authorize/brand/check_partner',
    method: 'get',
    loading: true,
  };
}
